import React, { Component } from 'react';

class Dashboard extends Component {
  render() {
    return (
      <div className="animated fadeIn">
       <p>client content </p><br/>
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js